<template>
  <div v-loading="loading" class="app-container">
    <div class="form-container">
      <div class="form-item common-card">
        <div class="card-content">
          <div class="card-content__item">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              请输入名称：
            </p>
            <el-input v-model="form.title" class="card-content__item--input" />
          </div>
          <div class="card-content__item">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              请选择分类：
            </p>
            <el-select v-model="form.type" @change="form.content = ''">
              <el-option label="跳外链" value="1" />
              <el-option label="自定义编辑" value="2" />
              <el-option label="不跳转" value="3" />
              <el-option label="跳转页面" value="4" />
            </el-select>
          </div>
          <div class="card-content__item">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              是否上架：
            </p>
            <el-select v-model="form.status">
              <el-option label="上架" value="1" />
              <el-option label="下架" value="0" />
            </el-select>
          </div>
          <div class="card-content__item">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              广告位：
            </p>
            <el-select v-model="form.location">
              <el-option label="首页" value="0" />
              <el-option label="充电页" value="1" />
            </el-select>
          </div>
          <div class="card-content__item flex">
            <div class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              请选择封面：
            </div>
            <div class="upload_banner">
              <com-upload
                :originData="form.photo"
                @postImage="postImage"
                @deleteImageUrl="deleteImageUrl"
              ></com-upload>
              <div class="mt-5px" v-if="form.location === '0'">(702*220)</div>
              <div class="mt-5px" v-if="form.location === '1'">(702*174)</div>
            </div>
          </div>
          <div class="card-content__item">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              请输入排序：
            </p>
            <el-input v-model="form.sort" class="card-content__item--input" />
          </div>
          <div class="card-content__item" v-if="form.type == 2">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              内容信息：
            </p>
            <Tinymce @listenChangeEditorValue="changeEditorValue" :value="form.content" />
          </div>
          <div class="card-content__item" v-if="form.type == 1">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              外链链接：
            </p>
            <el-input v-model="form.link" />
          </div>
          <div class="card-content__item" v-if="form.type == 4">
            <p class="card-content__item--title">
              <span class="card-content__item--title-star">*</span>
              跳转页面：
            </p>
            <el-input v-model="form.link" />
          </div>
        </div>
      </div>
    </div>

    <div class="operation-container">
      <el-button @click="submitForm" :loading="btnLoading" type="primary">提交表单</el-button>
      <el-button @click="$router.go(-1)">取消</el-button>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/tinymce'
import { getBanner, submitBanner, bannerUpdate } from '@/api/banners'

export default {
  components: {
    Tinymce
  },

  data() {
    return {
      loading: true,
      btnLoading: false,

      form: {
        code: '',
        title: '', // 标题
        type: '', // 跳转类型
        photo: '', // 图片
        sort: '', // 排序
        status: '',
        content: '',
        link: '',
        location: ''
      },
      categories: []
    }
  },

  created() {
    this.form.code = this.$route.params && this.$route.params.code

    if (this.form.code) {
      getBanner({ code: this.form.code }).then((res) => {
        console.log('res :>> ', res)
        this.$resetForm(this.form, res.data.banner)
        this.loading = false
      })
    } else {
      this.loading = false
    }
  },

  methods: {
    changeEditorValue(val) {
      this.form.content = val
    },

    postImage(url) {
      this.form.photo = url
    },
    deleteImageUrl() {
      this.form.photo = ''
    },

    submitForm() {
      this.loading = true

      const form = JSON.parse(JSON.stringify(this.form))

      if (form.code) {
        console.log(' 编辑:>> ')
        bannerUpdate(form)
          .then(() => {
            this.$message.success('提交成功')
            this.$router.go(-1)
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
        return
      }

      submitBanner(form)
        .then(() => {
          this.$message.success('提交成功')
          this.$router.go(-1)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 95px;

  .form-item {
    flex: 1;

    &:nth-child(2) {
      margin: 0 16px;
    }

    .header-ribbon {
      display: flex;
      margin: 15px;
      padding: 12px 15px;
      border-radius: 6px;
      background-color: #f7f8fa;

      &::before {
        margin-top: 3px;
        margin-right: 8px;
        width: 3px;
        height: 14px;
        background-color: #155bd4;
        content: '';
      }

      .header-ribbon--title {
        margin-left: 5px;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        color: #333;
      }
    }

    .card-content {
      margin: 30px;

      .card-content__item {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-top: 25px;

        .card-content__item--title {
          margin-bottom: 10px;
          font-size: 16px;
          color: #666;

          .card-content__item--title-star {
            color: red;
          }
        }

        .card-content__item--input {
          width: 240px;
        }
      }
    }
  }
}

.operation-container {
  display: flex;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 190px;
  padding: 15px 0;
  background-color: #fff;
  border-top: 2px solid rgb(237, 240, 247);
}
</style>
<style lang="scss">
.upload_banner {
  .image-upload {
    position: relative;
  }
}
</style>
